import { h } from 'vue'
import OrganismProductTour from '~/components/organisms/product-tour/product-tour.vue'

const Functional = () => {
  return h(OrganismProductTour)
}

Functional.props = {}

export default Functional
